import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FundType } from '../../../../../../models/transactions/fund-type';

@Component({
  selector: 'app-vb-review-withdrawal-details-withdrawal-instruction',
  templateUrl: './vb-review-withdrawal-details-withdrawal-instruction.component.html',
  styleUrls: ['./vb-review-withdrawal-details-withdrawal-instruction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbReviewWithdrawalDetailsWithdrawalInstructionComponent {
  @Input() balance!: number;
  @Input() percentage!: number;
  @Input() fundType!: FundType;
}
